var spoiler_default = {
  "fontElementMap": "UfYlK",
  "hideText": "sF3S7",
  "onHoverText": "oYmDj",
  "hideBlock": "V3TF2",
  "smallBlur": "ScTBx",
  "mediumBlur": "_-2zZy",
  "largeBlur": "i-6vX",
  "hideBlock_gallery": "mTHow",
  "overlay": "OBdOd",
  "overlay_gallery": "_0peG3",
  "revealSpoilerBtn": "wQMoI",
  "isMobile": "Z66rz",
  "onHoverBtn": "twOdR",
  "spoilerWrapper": "_1YBDv",
  "spoilerDescription": "hVgrg",
  "spoilerContainer": "_4Wus5",
  "spoilerContainer_Gallery": "d0GoS"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
